import bootstrapNotify from '../../../../../../modules/Gull/Framework/bootstrapNotify.js';
import validation from '../../../../../../modules/Gull/Framework/validation.js';
import moment from '../../../../../../../vendor/moment/dist/moment.js';
// import logoutTimer from './valideerActie/logoutTimer.js';

const valideerActie = {

	init() {

		// logoutTimer.init();

		// Toon waarschuwing als deze actie reeds wordt bewerkt
		if ($('#claimModal').length) {
			$('#claimModal').modal({
				backdrop: 'static',
				keyboard: false
			}, 'show');
		}

		// Functie om te voorkomen dat een dropdown dicht gaat als er op een select geklikt wordt
		$('#content-wrapper .dropdown-menu').on('click', function(e) {
			e.stopPropagation();
		});

		// Toon en verberg aanvullende validatie velden bij valideer met of zonder wijziging
		$('.valideerMetWijziging').change(function() {
			var t = $(this).closest('form').find('.verbergZonderWijziging').closest('.form-group');
			if ($(this).val() == 'metWijziging') {
				t.removeClass('d-none').find('input,select').not('#NR_SCHMIJ').each(function(i, e) {
					validation.addRequired(e);
				});
			} else {
				t.removeClass('d-none').addClass('d-none').find('input,select').each(function(i, e) {
					validation.removeRequired(e);
				});
			}
		});
		$('.valideerMetWijziging').trigger('change');

		// Toon en verberg einddatum wanneer bekend
		$('select[name="stopzettenEinddatumBekend"]').change(function() {
			var t = $('.stopzetten-einddatum').closest('.form-group').parent('div');
			if ($(this).val() == 'einddatumBekend') {
				t.removeClass('d-none').find('input,select').each(function(i, e) {
					validation.addRequired(e);
				});
			} else {
				t.addClass('d-none').find('input,select').each(function(i, e) {
					validation.removeRequired(e);
				});
			}
		});
		$('#stopzettenEinddatumBekend').trigger('change');

		// Vul standaard reden in reden veld in
		$('#afwijzenStandaardReden').change(function() {
			var value = $(this).val();
			if (value != '') {
				if ($('#afwijsReden').val() != '') {
					bootstrapNotify('danger', 'Let op:', 'Er staat al text in het reden veld. Verwijder dit eerst.');
					$(this).val('');
				} else {
					$('#afwijsReden').val($(this).find('option[value="' + $(this).val() + '"]').text().trim()).trigger('blur');
				}
			}
		});

		$('select.VervolgActie').change(function() {
			var t = $(this).closest('form').find('.ExtraCheckDefault');
			if ($(this).val() == 'claimbeheer|ExtraCheck') {
				t.closest('.form-group').removeClass('d-none');
				validation.addRequired(t);
			} else {
				t.closest('.form-group').addClass('d-none');
				validation.removeRequired(t);
			}
		});

		$('select.ExtraCheckDefault').change(function() {
			var t = $(this).closest('form').find('.ExtraCheck');
			if ($(this).val() == 'anders') {
				t.closest('.form-group').removeClass('d-none');
				validation.addRequired(t);
			} else {
				t.val($(this).val()).closest('.form-group').addClass('d-none');
				validation.removeRequired(t);
			}
		});

		// Vul standaard reden in reden veld in
		$('#rappelAction').change(function() {
			var value = $(this).val();
			if (value !== 'rappel_verzenden_zonder') {
				$('#rappelReden').val($(this).find('option[value="' + $(this).val() + '"]').text().trim()).trigger('blur');
			}
		});


		$('.meldingsdatum-aanpassen').click(function() {
			$('#meldingsdatumModal').modal('show');
		});

		$('.uitkeringsgrondslag-bewerken').click(function() {
			valideerActie.showUitkeringsgrondslagModal(this, 'bewerken');
		});

		$('.uitkeringsgrondslag-verwijderen').click(function() {
			valideerActie.showUitkeringsgrondslagModal(this, 'verwijderen');
		});

		$('.uitkeringsgrondslag-nieuw').click(function() {
			valideerActie.showUitkeringsgrondslagModal(this, 'toevoegen');
			$('#uitkeringsGrondslagModal').find('input[name="uitkeringsgrondslag_id"]').val('');
			$('#uitkeringsGrondslagModal').find('.form-group').removeClass('has-error').find('input,select').removeClass('is-invalid');
		});


		$('.actie-wijzigen').click(function() {
			valideerActie.showActieModal(this, 'wijzigen');
		});


		$('.signalering-bewerken').click(function() {
			valideerActie.showSignaleringModal(this, 'bewerken');
		});

		$('.signalering-verwijderen').click(function() {
			valideerActie.showSignaleringModal(this, 'verwijderen');
		});

		$('.signalering-nieuw').click(function() {
			valideerActie.showSignaleringModal(this, 'toevoegen');
			$('#signaleringModal').find('input[name="signalering_id"]').val('');
			$('#signaleringModal').find('.form-group').removeClass('has-error').find('input,select').removeClass('is-invalid');
		});

		// Toon en verberg einddatum wanneer bekend
		$('select[name="EinddatumBekend"]').change(function() {
			var t = $('input[name="Einddatum"]').closest('.form-group').parent('div');
			if ($(this).val() == 'einddatumBekend') {
				t.removeClass('d-none').find('input,select').each(function(i, e) {
					validation.addRequired(e);
				});
			} else {
				t.addClass('d-none').find('input,select').each(function(i, e) {
					validation.removeRequired(e);
				});
			}
		});

		// Toon en verberg rappel signalering
		$('select#rappelAction').change(function() {
			var t = $('.form-section-met-rappel').find('input,select');
			if ($(this).val() == 'rappel_verzenden_met') {
				t.each(function(i, e) {
					$(e).closest('.form-group').removeClass('d-none');
					validation.addRequired(e);
				});
			} else {
				t.each(function(i, e) {
					$(e).closest('.form-group').addClass('d-none');
					validation.removeRequired(e);
				});
			}
		});

		// Functie om text op countdown knop te wijzigen
		$('#actionCountdownButton').hover(function() {
			$(this).find('.btn-inner').addClass('d-none');
			$(this).find('.btn-hover').removeClass('d-none');
		}, function() {
			$(this).find('.btn-hover').addClass('d-none');
			$(this).find('.btn-inner').removeClass('d-none');
		});

		// Zet soort betaling op bruto als de betaling aan werkgever of uwv dient te
		$('body').on('change', '#betalingAan', function() {
			var t = $(this).closest('form').find('#soortBetaling');
			if ($(this).val() == 'uwv' || $(this).val() == 'werkgever') {
				t.val('bruto');
				t.find('option[value=netto]').attr('disabled', 'true');
			} else {
				t.find('option[value=netto]').removeAttr('disabled');
			}
		});

		// Toon IBAN als betaling aan werkgever wordt gedaan
		$('body').on('change', '#betalingAan', function() {
			var t = $(this);
			var v = t.val();
			var w = $('.werkgeverIBAN');
			var i = w.closest('.form-group');
			var n = $('input[name=VOLGNR_BANK');
			if (v !== 'uwv') {
				i.removeClass('d-none');
				validation.addRequired(w);
			} else {
				validation.removeRequired(w);
				i.addClass('d-none');
				w.val('');
				n.val('');
			}
		});

		// Toon IBAN als betaling aan werkgever wordt gedaan
		$('body').on('change', '.werkgeverIBAN', function(e) {
			$('input[name=VOLGNR_BANK').val($(e.target).children('option:selected').data('nr'));
		});

		// Toon loonheffingkorting als betaling aan werknemer wordt gedaan
		$('body').on('change', '#betalingAan', function() {
			var t = $(this);
			var v = t.val();
			var w = $('.loonheffingskorting');
			var i = w.closest('.form-group');
			w.val('');
			if (v == 'werknemer') {
				i.removeClass('d-none');
				validation.addRequired(w);
			} else {
				validation.removeRequired(w);
				i.addClass('d-none');
			}
		});

		// Toon Zvw velden als betaling aan werknemer wordt gedaan
		$('body').on('change', '#betalingAan', function() {
			var t = $(this);
			var v = t.val();
			var b = $('.zvwBijdrage');
			var bg = b.closest('.form-group');
			var p = $('.zvwBijdragePercentage');
			var pg = p.closest('.form-group');
			if (v == 'werknemer') {
				bg.removeClass('d-none');
				validation.addRequired(b);
				pg.removeClass('d-none');
				validation.addRequired(p);
			} else {
				bg.addClass('d-none');
				validation.removeRequired(b);
				pg.addClass('d-none');
				validation.removeRequired(p);
				b.val('');
				p.val('');
			}
		});

		// Pas juiste Zvw percentage toe wanneer zvwBijdrage wordt
		$('body').on('change', '.zvwBijdrage', function() {
			var v = $(this).find('option:selected').data('percentage');
			$('.zvwBijdragePercentage').val(v);
		});

		// Toon en verberg aanvullende validatie velden bij valideer met of zonder wijziging
		$('.polisnummer').change(function() {
			var t = $(this).closest('form').find('.verbergZonderWijziging').closest('.form-group');
			if ($(this).val() !== '') {
				t.removeClass('d-none').find('input,select').each(function() {
					// validation.addRequired(e);
				});
				$('.betaling-aan').trigger('change');
			} else {
				t.removeClass('d-none').addClass('d-none').find('input,select').each(function(i, e) {
					validation.removeRequired(e);
				});
			}
		});
		$('.polisnummer').trigger('change');

		// Toon en verberg Betaling aan opties
		$('.modal .polisnummer').change(function() {

			var p = $(this).find('option:selected').data('prod');
			var v = p.toString();

			var inputBetalingAan = $('.modal select.betaling-aan');
			var soortBetaling = $('.modal select.soort-betaling');
			var berekening = $('.modal .berekening');
			var datumBrief = $('.modal .datum-brief');
			var betaalDatum = $('.modal .betaal-datum');
			var brutoLoon = $('.modal .bruto-loon');
			var betalingsKenmerk = $('.modal .betalings-kenmerk');
			var toelichtingUpload = $('.modal .toelichting-upload');
			var betalingBrief = $('.modal .betaling-brief');
			var bewijsOverboeking = $('.modal .bewijs-overboeking');

			if (v == '') {

				$('.verbergZonderWijziging').closest('.form-group').addClass('d-none');

			} else if (v == 720 || v == 721 || v == 722 || v == 725 || v == 927 || v == 928 || v == 929) {

				inputBetalingAan.find('option[value=werknemer]').addClass('d-none');
				inputBetalingAan.find('option[value=uwv]').removeClass('d-none');

				soortBetaling.find('option[value=netto]').addClass('d-none');

				berekening.closest('.form-group').addClass('d-none');
				validation.removeRequired(berekening);

				datumBrief.closest('.form-group').removeClass('d-none');
				validation.addRequired(datumBrief);

				betaalDatum.closest('.form-group').removeClass('d-none');
				validation.addRequired(betaalDatum);

				brutoLoon.closest('.form-group').removeClass('d-none');
				// validation.addRequired(brutoLoon);

				betalingsKenmerk.closest('.form-group').removeClass('d-none');
				// validation.addRequired(betalingsKenmerk);

				betalingBrief.removeClass('d-none');
				// validation.addRequired(betalingBrief.find('input'));

				bewijsOverboeking.removeClass('d-none');
				// validation.addRequired(bewijsOverboeking.find('input'));

				toelichtingUpload.addClass('d-none');
				validation.removeRequired(toelichtingUpload.find('input'));

			} else {

				inputBetalingAan.find('option[value=werknemer]').removeClass('d-none');
				inputBetalingAan.find('option[value=uwv]').addClass('d-none');

				soortBetaling.find('option[value=netto]').removeClass('d-none');

				berekening.closest('.form-group').removeClass('d-none');
				validation.removeRequired(berekening);

				datumBrief.closest('.form-group').addClass('d-none');
				validation.removeRequired(datumBrief);

				betaalDatum.closest('.form-group').addClass('d-none');
				validation.removeRequired(betaalDatum);

				brutoLoon.closest('.form-group').addClass('d-none');
				validation.removeRequired(brutoLoon);

				betalingsKenmerk.closest('.form-group').addClass('d-none');
				validation.removeRequired(betalingsKenmerk);

				betalingBrief.addClass('d-none');
				validation.removeRequired(betalingBrief.find('input'));

				bewijsOverboeking.addClass('d-none');
				validation.removeRequired(bewijsOverboeking.find('input'));

				toelichtingUpload.removeClass('d-none');

			}
		});

		// Toon of verberg volledige beschrijving in log
		$('.log-beschrijving-toggle').click(function(e) {
			e.preventDefault();
			var p = $(this).closest('table');
			var f = p.find('.beschrijving-full');
			var s = p.find('.beschrijving-short');
			if (f.hasClass('d-none')) {
				f.removeClass('d-none');
				s.addClass('d-none');
				$(this).text('Lees minder...');
			} else {
				f.addClass('d-none');
				s.removeClass('d-none');
				$(this).text('Lees meer...');
			}
		});

		// Maak nieuwe betaling modal leeg wanneer deze geopend wordt
		$('button.betaling-toevoegen').click(function() {
			$('#betalingToevoegenModal').find('input, select').not('[type="hidden"]').val('');
			$('#betalingToevoegenModal select.polisnummer').trigger('change');
			$('#betalingToevoegenModal').find('input[type="upload"]').each(function(i, e) {
				$(this).addClass('d-none');
				validation.removeRequired(e);
			});
		});

		// Trigger change op upload modal als op validatieknop geklikt wordt
		$('button[data-target="#valideerModal"]').click(function() {
			$('#valideerModal select.polisnummer').trigger('change');
		});

		// Bind functie om de claimdagen te berekenen
		$('.input-claimdagen-berekenen').on('change', function(e) {
			valideerActie.berekenClaimDagen(e);
		});



	},

	showUitkeringsgrondslagModal: function(this_item, type) {
		if (type == 'verwijderen') {
			$('#uitkeringsGrondslagModal').find('input[name="action"]').val('uitkeringsgrondslag_verwijderen');
			var button_txt = 'Verwijderen';
			var button_class = 'btn-danger';
		} else {
			$('#uitkeringsGrondslagModal').find('input[name="action"]').val('uitkeringsgrondslag_wijzigen');
			button_txt = 'Opslaan';
			button_class = 'btn-primary';
		}
		$('#uitkeringsGrondslagModal .modal-footer button[type="submit"]').text(button_txt).removeClass('btn-primary').removeClass('btn-danger').addClass(button_class);

		$('#uitkeringsGrondslagModal #uitkeringsGrondslagModalLabel span').text(type);

		var uitkeringsgrondslag_id = $(this_item).closest('tr').data('uitkeringsgrondslag_id');
		$('#uitkeringsGrondslagModal').find('input[name="uitkeringsgrondslag_id"]').val(uitkeringsgrondslag_id);

		$('#uitkeringsGrondslagModal').find('input[name="Begindatum"]').val($(this_item).closest('tr').find('td.Begindatum').text()).trigger('blur');
		$('#uitkeringsGrondslagModal').find('input[name="Begindatum"]').datepicker('update');

		$('#uitkeringsGrondslagModal').find('select[name="Periode"]').val($(this_item).closest('tr').find('td.Periode').text()).trigger('blur');
		$('#uitkeringsGrondslagModal').find('input[name="PeriodeLoon"]').val($(this_item).closest('tr').find('td.PeriodeLoon').data('value')).trigger('blur');
		$('#uitkeringsGrondslagModal').find('select[name="Type"]').val($(this_item).closest('tr').find('td.Type').text()).trigger('blur');

		$('#uitkeringsGrondslagModal').modal('show');
	},

	showActieModal: function(this_item, type) {
		if (type == 'intrekken') {
			$('#actieModal').find('input[name="action"]').val('actie_intrekken');
			var button_txt = 'Intrekken';
			var button_class = 'btn-danger';
		} else {
			$('#actieModal').find('input[name="action"]').val('actie_wijzigen');
			button_txt = 'Opslaan';
			button_class = 'btn-primary';
		}
		$('#actieModal .modal-footer button[type="submit"]').text(button_txt).removeClass('btn-primary').removeClass('btn-danger').addClass(button_class);

		$('#actieModal #actieModalLabel span').text(type);

		var actie_id = $(this_item).closest('tr').data('actie_id');
		$('#actieModal').find('input[name="actie_id"]').val(actie_id);

		$('#actieModal').modal('show');
	},

	showSignaleringModal: function(this_item, type) {
		if (type == 'verwijderen') {
			$('#signaleringModal').find('input[name="action"]').val('signalering_verwijderen');
			var button_txt = 'Verwijderen';
			var button_class = 'btn-danger';
		} else {
			$('#signaleringModal').find('input[name="action"]').val('signalering_wijzigen');
			button_txt = 'Opslaan';
			button_class = 'btn-primary';
		}
		$('#signaleringModal .modal-footer button[type="submit"]').text(button_txt).removeClass('btn-primary').removeClass('btn-danger').addClass(button_class);

		$('#signaleringModal #signaleringModalLabel span').text(type);

		var signalering_id = $(this_item).closest('tr').data('signalering_id');
		$('#signaleringModal').find('input[name="signalering_id"]').val(signalering_id);

		$('#signaleringModal').find('input[name="Begindatum"]').val($(this_item).closest('tr').find('td.Begindatum').text()).trigger('blur');
		$('#signaleringModal').find('input[name="Begindatum"]').datepicker('update');

		var Einddatum = $(this_item).closest('tr').find('td.Einddatum').text().trim();
		if (Einddatum == '-' || type == 'toevoegen') {
			Einddatum = '';
			$('#signaleringModal').find('select[name="EinddatumBekend"]').val('einddatumNietBekend').trigger('change');
		} else {
			$('#signaleringModal').find('select[name="EinddatumBekend"]').val('einddatumBekend').trigger('change');
		}
		$('#signaleringModal').find('input[name="Einddatum"]').val(Einddatum).trigger('blur');
		$('#signaleringModal').find('input[name="Einddatum"]').datepicker('update');
		$('#signaleringModal').find('input[name="PeriodeLoon"]').val($(this_item).closest('tr').find('td.PeriodeLoon').data('value')).trigger('blur');
		$('#signaleringModal').find('select[name="Type"]').val($(this_item).closest('tr').find('td.Type').text()).trigger('blur');

		$('#signaleringModal').modal('show');
	},

	// Functie om de claimdagen te berekenen
	berekenClaimDagen: function(e) {
		var d = $(e.target).val();
		if (typeof d !== 'undefined') {
			d = d.split('-');
			d = d[1] + '/' + d[0] + '/' + d[2];
		}
		var t = moment().format('l');
		var gewenst = new Date(d);
		var vandaag = new Date(t);
		var difference = Math.abs(gewenst - vandaag);
		var days = difference / (1000 * 3600 * 24);
		var claimdagen = (parseInt(days) / 7) * 5;
		claimdagen = Math.floor(claimdagen);
		if (!isNaN(claimdagen)) {
			$('.input-claimdagen').val(claimdagen);
		}
	}

};

export default valideerActie;
